import React from 'react';
import classNames from 'classnames';

import { IconTypes } from '../../../types';

type TelusInternationalProps = {
  variant?: 'original' | 'black' | 'white';
};

export const TelusInternational = ({
  className,
  width = 189,
  height = 24,
  variant = 'original',
  ariaHidden = true,
  isClickable = false,
}: TelusInternationalProps & IconTypes): React.ReactElement => {
  const defaultClass = classNames(
    'sui-fill-current',
    { 'sui-pointer-events-none': !isClickable },
    className
  );

  let color1;
  let color2;

  switch (variant) {
    case 'black':
      color1 = '#000';
      color2 = '#000';
      break;

    case 'white':
      color1 = '#fff';
      color2 = '#fff';
      break;

    case 'original':
      color1 = '#4B286D';
      color2 = '#66CC00';
      break;
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 189 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={defaultClass}
      aria-hidden={ariaHidden}
    >
      <path
        d="M137.412 4.06799H142.155C146.317 4.06799 148.745 6.6072 148.745 10.7137C148.745 14.8202 146.317 17.3594 142.155 17.3594H137.412V4.06799ZM142.135 15.6089C145.066 15.6089 146.653 13.8177 146.653 10.7137C146.653 7.60965 145.066 5.82356 142.135 5.82356H139.407V15.6089H142.135Z"
        fill={color1}
      />
      <path
        d="M150.185 5.31978C150.185 4.70406 150.689 4.17993 151.325 4.17993C151.961 4.17993 152.464 4.6837 152.464 5.31978C152.464 5.95585 151.961 6.45962 151.325 6.45962C150.689 6.45962 150.185 5.95585 150.185 5.31978ZM150.388 7.72668H152.256V17.3645H150.388V7.72668Z"
        fill={color1}
      />
      <path
        d="M154.444 18.0362H156.311C156.459 19.1761 157.304 19.7358 158.718 19.7358C160.474 19.7358 161.425 18.8199 161.425 17.049V15.9855C160.733 16.9371 159.69 17.4816 158.327 17.4816C155.655 17.4816 153.899 15.5021 153.899 12.4948C153.899 9.4874 155.635 7.50793 158.306 7.50793C159.726 7.50793 160.81 8.1033 161.502 9.09558V7.73183H163.293V17.0134C163.293 19.5323 161.782 21.2522 158.698 21.2522C156.082 21.2522 154.627 19.9648 154.439 18.0413L154.444 18.0362ZM161.481 12.4897C161.481 10.3423 160.377 9.11084 158.662 9.11084C156.948 9.11084 155.843 10.4186 155.843 12.4897C155.843 14.5607 156.948 15.8685 158.662 15.8685C160.377 15.8685 161.481 14.6371 161.481 12.4897Z"
        fill={color1}
      />
      <path
        d="M165.201 5.31978C165.201 4.70406 165.705 4.17993 166.341 4.17993C166.977 4.17993 167.481 4.6837 167.481 5.31978C167.481 5.95585 166.977 6.45962 166.341 6.45962C165.705 6.45962 165.201 5.95585 165.201 5.31978ZM165.405 7.72668H167.272V17.3645H165.405V7.72668Z"
        fill={color1}
      />
      <path
        d="M170.132 15.2171V9.2584H168.58V7.72673H170.132V4.96362H172V7.72673H173.943V9.2584H172V15.0492C172 15.609 172.279 15.8736 173.104 15.8736H173.943V17.3696C173.531 17.4052 173.139 17.4256 172.804 17.4256C171.068 17.4256 170.132 16.8302 170.132 15.2171Z"
        fill={color1}
      />
      <path
        d="M181.393 16.0567C180.742 17.0643 179.658 17.5884 178.253 17.5884C176.182 17.5884 174.819 16.5809 174.819 14.7286C174.819 13.1766 175.75 12.0011 178.442 11.7416L179.861 11.594C180.793 11.4821 181.302 11.1666 181.302 10.383C181.302 9.48736 180.833 8.99885 179.322 8.99885C177.811 8.99885 177.175 9.4263 177.083 10.7341H175.236C175.348 8.79022 176.432 7.50281 179.327 7.50281C182.223 7.50281 183.139 8.66301 183.139 10.3422V15.441C183.139 15.7412 183.286 15.9244 183.663 15.9244H184.187V17.3645C183.907 17.4001 183.571 17.4205 183.271 17.4205C182.075 17.4205 181.536 16.993 181.403 16.0567H181.393ZM178.538 16.1331C179.902 16.1331 181.302 15.3698 181.302 13.5582V12.5507C181.022 12.7746 180.63 12.8865 180.106 12.9425L178.762 13.0901C177.21 13.2784 176.747 13.8178 176.747 14.6777C176.747 15.5377 177.327 16.1331 178.538 16.1331Z"
        fill={color1}
      />
      <path
        d="M185.332 15.2171V4.06799H187.199V15.0492C187.199 15.6089 187.443 15.8735 188.13 15.8735H188.822V17.3696C188.451 17.4052 188.074 17.4256 187.779 17.4256C186.192 17.4256 185.332 16.8302 185.332 15.2171Z"
        fill={color1}
      />
      <path
        d="M127.907 4.06799C128.66 4.06799 129.291 4.66336 129.291 5.44191C129.291 6.22047 128.66 6.8311 127.907 6.8311C127.154 6.8311 126.513 6.23573 126.513 5.44191C126.513 4.64809 127.149 4.06799 127.907 4.06799ZM127.907 6.62756C128.548 6.62756 129.042 6.1187 129.042 5.44191C129.042 4.76513 128.548 4.27154 127.907 4.27154C127.266 4.27154 126.767 4.7804 126.767 5.44191C126.767 6.10343 127.261 6.62756 127.907 6.62756ZM127.368 4.63792H127.993C128.375 4.63792 128.558 4.79057 128.558 5.10098C128.558 5.39103 128.375 5.51315 128.131 5.5386L128.594 6.251H128.324L127.887 5.55895H127.622V6.251H127.373V4.63792H127.368ZM127.617 5.35541H127.881C128.1 5.35541 128.309 5.34523 128.309 5.0908C128.309 4.87708 128.126 4.84146 127.953 4.84146H127.622L127.617 5.35541Z"
        fill={color1}
      />
      <path
        d="M74.8634 6.64787V4.06287H65.6479V17.3594H74.8634V14.6624H69.383V11.7161H73.9424V9.13111H69.383V6.64787H74.8634Z"
        fill={color1}
      />
      <path d="M91.1266 14.7336H85.3663V4.06287H81.5854V17.3594H91.1266V14.7336Z" fill={color1} />
      <path
        d="M121.556 9.13112C119.007 8.55611 118.116 8.48996 118.116 7.47733C118.116 6.53594 119.378 6.2408 120.106 6.2408C121.287 6.2408 122.671 6.51558 124.08 7.24325L125.108 4.79564C123.663 4.00182 121.801 3.67615 120.009 3.67615C116.493 3.67615 114.132 5.10095 114.035 7.88442C113.934 10.4185 115.994 11.3701 117.893 11.7619C119.719 12.1385 121.572 12.4642 121.612 13.548C121.648 14.5505 120.747 14.9779 119.048 14.9779C117.475 14.9779 116.01 14.4741 114.514 13.8482L113.644 16.5045C115.358 17.2373 117.104 17.6392 118.905 17.6392C121.404 17.6392 123.225 17.2525 124.569 15.9905C125.5 15.1255 125.805 14.0823 125.805 13.085C125.8 10.9783 124.492 9.79264 121.556 9.13112Z"
        fill={color1}
      />
      <path
        d="M60.2897 6.68349V4.06287H48.6927V6.68349H52.611V17.3594H56.3663V6.68349H60.2897Z"
        fill={color1}
      />
      <path
        d="M104.016 4.06287V12.5099C104.016 13.1715 104.016 13.3546 103.975 13.6142C103.858 14.4182 103.075 14.8863 101.828 14.9016C100.907 14.8863 100.23 14.6166 99.9146 14.1332C99.7568 13.8839 99.6805 13.4411 99.6805 12.7287V4.06287H95.7623V13.2274C95.7623 14.4996 95.9302 15.0695 96.5052 15.7921C97.4517 16.9777 99.2938 17.5985 101.838 17.5985C101.863 17.5985 101.894 17.5985 101.919 17.5985C101.935 17.5985 101.955 17.5985 101.975 17.5985C105.375 17.5985 107.13 16.2704 107.639 15.0288C107.893 14.4283 107.914 14.1434 107.914 12.9272V4.06287H104.016Z"
        fill={color1}
      />
      <path
        d="M50.4636 0.419474L28.491 4.79567V6.32733L28.5623 6.30698C43.08 2.78058 50.4636 0.658638 50.5246 0.643372C50.6061 0.623017 50.6366 0.556866 50.6264 0.50598C50.6111 0.450006 50.5501 0.404209 50.4636 0.419474Z"
        fill={color1}
      />
      <path
        d="M32.0174 1.64072C32.3584 1.42191 32.4551 1.5593 32.3533 1.80355C32.1904 2.19537 31.4475 4.57684 25.9162 9.11586C24.4711 10.2964 23.4482 10.963 21.367 12.1945C24.7764 7.42645 29.7428 3.1215 32.0174 1.64072ZM32.5924 0.00219019C31.5238 0.0632533 29.5444 1.64581 28.4605 2.5872C24.1352 6.32731 20.9243 9.7672 18.5835 13.3648C13.7087 15.9753 7.50059 18.657 1.32812 20.7535L1.18564 20.8044L0 24L0.676784 23.7354C4.60009 22.2393 11.1491 19.4304 17.0875 16.3111C16.7516 17.2016 16.5837 18.0209 16.5837 18.7689C16.5837 19.3287 16.6753 19.8426 16.8636 20.3159C17.2351 21.2522 17.9729 21.9646 18.9906 22.3717C20.5121 22.9772 22.5832 22.9925 24.9494 22.275C30.9895 20.4431 38.1594 14.8202 39.7216 13.7007L39.7775 13.66C39.8386 13.6142 39.8437 13.548 39.8182 13.5022C39.7826 13.4513 39.7114 13.4361 39.6554 13.4717L39.5791 13.5175C37.9049 14.5199 29.7683 19.349 24.4761 20.7687C21.7843 21.4913 19.7285 21.0944 18.955 20.0105C18.6853 19.6391 18.5581 19.1709 18.5581 18.6264C18.5581 17.5629 19.0568 16.2043 20.0287 14.698C20.9192 14.1892 21.7487 13.6956 22.4967 13.2274C27.6565 10.3269 33.6051 4.68878 33.8544 1.2489C33.8544 1.22345 33.8544 1.19801 33.8544 1.17257C33.8544 0.877428 33.7272 0.572113 33.4982 0.343126C33.2591 0.103962 32.9385 -0.0181642 32.5924 0.00219019Z"
        fill={color2}
      />
      <path
        d="M28.4147 4.81097L5.2972 9.78252L4.40161 12.1843L28.4859 6.32737L28.5266 6.31719V4.78552L28.4147 4.81097Z"
        fill={color1}
      />
    </svg>
  );
};
